module.exports = "/fonts/vendor/boxicons/boxicons.svg?dad92ba1a4eed23afdbd3df53657fe9a";